module.exports = __webpack_public_path__ + "img/6.1.0d3f8d5e.png";